export default "__VITE_ASSET__BvpZpiXw__"